import React from "react"
import axios from "axios";
import { MapMenuContext } from "../MapMenu"
import * as settings from "../../../settings"
import { MenuItem, Typography, ListItemIcon, ListItemText } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Plan, RedistrictingData, RedistrictingDataID, MapDrawerOpen } from "../../../atom/atom"
import {
    useRecoilValue,
    useSetRecoilState,
    useRecoilState
} from 'recoil';

export const GetBlockData = () => {
    const plan = useRecoilValue(Plan)
    const [redistrictingdata, setRedistrictingData] = useRecoilState(RedistrictingData)
    const [drawerOpen, setDrawerOpen] = useRecoilState(MapDrawerOpen);
    const setRedistrictingDataID = useSetRecoilState(RedistrictingDataID)
    const ctx = React.useContext(MapMenuContext)

    const getBlockData = () => {
        const e = ctx.mapClickEvent
        const nextID = redistrictingdata.length
        console.log(e)
        if (!e) return
        const lng = e.lngLat.lng
        const lat = e.lngLat.lat

        axios.get(`${settings.API_SERVER}/api/geometry/block_data/${plan}/${lng}/${lat}`)
            .then((res) => {
                // const label = res.data[0].blockgeo
                setRedistrictingData([...redistrictingdata, res.data])
                setRedistrictingDataID(nextID)
            })
            .catch((error) => {
                console.log(error)
            })
        ctx.setAnchorPt({})
        if (!drawerOpen) { setDrawerOpen(true) }
    }

    return (
        <MenuItem onClick={getBlockData}>
            <ListItemIcon>
                <InfoOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>
                <Typography variant="body2">
                    View block data
                </Typography>
            </ListItemText>
        </MenuItem>
    )
}
